<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Vevői tételes lista</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20" type="flex" justify="around">
          <el-col :span="16" style="display: flex; ">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px;"
                @change="handleChange"
              />
            </el-form-item>
            <el-form-item style="margin-right: 10px;"
                          label="Vevő"
            >
              <el-select
                v-model="customer"
                filterable
                remote
                :remote-method="searchCustomer"
                :loading="customerLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="handleChange"
                clearable
              >
                <el-option
                  v-for="p in customers"
                  :key="p.company.id"
                  :value="p"
                  :label="p.company.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="Raktár"
            >
              <el-select
                v-model="storage"
                value-key="id"
                style="width: 100%;"
                filterable
                @change="handleChange"
              >
                <el-option
                  v-for="s in storages"
                  :key="s.id"
                  :label="s.name"
                  :value="s"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-row type="flex" justify="end" style="margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
<!--              <el-button-->
<!--                :loading="printLoading"-->
<!--                icon="el-icon-printer"-->
<!--                @click="print"-->
<!--              >-->
<!--                Nyomtatás-->
<!--              </el-button>-->
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :data="data"
        style="width: 100%"
        row-key=""
        border
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              :data="props.row.items"
              style="width: 100%"
              border
            >
              <el-table-column
                prop="count"
                label="Cikkszám"
                width="100"
              >
                <template slot-scope="scope">
                  {{ scope.row.product_id }}
                </template>
              </el-table-column>
              <el-table-column
                prop="count"
                label="Termék"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.product_name }}
                </template>
              </el-table-column>

              <el-table-column
                prop="count"
                label="Mennyiség"
                show-overflow-tooltip
              >
              </el-table-column>


              <el-table-column
                prop="pack_type_name"
                label="Egység"
                width="200"
                show-overflow-tooltip
              >
              </el-table-column>

              <el-table-column
                prop="unit_price"
                label="Egységár"
                align="right"
              >
                <template slot-scope="scope">
                  {{ scope.row.unit_price | currency }}
                </template>
              </el-table-column>

              <el-table-column
                prop="net_price"
                label="Nettó"
                align="right"
              >
                <template slot-scope="scope">
                  {{ scope.row.net_price | currency }}
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          prop="partner_name"
          label="Partner"
        >
        </el-table-column>

        <el-table-column
          prop="summary"
          label="Nettó összesen"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.summary | currency }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
  import moment from 'moment';
  import {saveAs} from 'file-saver';


  export default {
    components: {},
    data() {
      const start = moment()
        .startOf('year')
        .format('Y-MM-DD');
      const end = moment()
        .format('Y-MM-DD');
      return {
        data: [],
        loading: false,
        currentPage: 1,
        downloadLoading: false,
        printLoading: false,
        customers: [],
        customer: null,
        storage: null,
        key: 1,
        supplierLoading: false,
        customerLoading: false,
        dateRange: [start, end],
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment()
                .weekday(1)
                .toDate();
              const end = moment()
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment()
                .subtract({weeks: 1})
                .weekday(1)
                .toDate();
              const end = moment()
                .subtract({weeks: 1})
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 1})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 3})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment()
                .subtract({years: 1})
                .startOf('year')
                .toDate();
              const end = moment()
                .subtract({years: 1})
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    computed: {
      storages() {
        return this.$store.getters['storage/storages'];
      },
    },
    watch: {},
    async mounted() {
      if (!this.storages.length) {
        await this.$store.dispatch('storage/fetchAll');
      }
      this.storage = this.storages.find(s => s.type === 'own');
      this.fetchData();
    },
    methods: {
      getKey() {
      },

      async download() {
        this.downloadLoading = true;
        try {
          const excel = await axios({
            url: `api/reports/invoice-items-by-partner/download`,
            method: 'POST',
            responseType: 'blob',
            data: {
              from: this.dateRange[0],
              to: this.dateRange[1],
              customer_id: this.customer ? this.customer.id : null,
              storage_id: this.storage ? this.storage.id : null,
            },
          });
          saveAs(excel, `invoiceitemsbypartner.xlsx`);
        } catch (e) {
        }
        this.downloadLoading = false;
      },

      // async print() {
      //   this.printLoading = true;
      //   const response = await axios.post('api/reports/invoice-items/print', {
      //     from: this.dateRange[0],
      //     to: this.dateRange[1],
      //     customer_id: this.customer ? this.customer.id : null,
      //     storage_id: this.storage ? this.storage.id : null,
      //   }, {
      //     responseType: 'arraybuffer',
      //     headers: {
      //       'Accept': 'application/pdf'
      //     },
      //   });
      //   this.printLoading = false;
      //
      //   const newBlob = new Blob([response], {type: 'application/pdf'});
      //   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //     window.navigator.msSaveOrOpenBlob(newBlob);
      //     return;
      //   }
      //
      //   const data = window.URL.createObjectURL(newBlob);
      //   window.open(data);
      // },

      async fetchData() {
        this.loading = true;
        let query = `api/reports/invoice-items-by-partner?from=${this.dateRange[0]}&to=${this.dateRange[1]}`

        if (this.customer) {
          query += `&customer_id=${this.customer.id}`
        }

        if (this.storage) {
          query += `&storage_id=${this.storage.id}`
        }

        this.data = await axios.get(query);
        this.loading = false;
      },

      async searchCustomer(query) {
        if (query !== '') {
          this.customerLoading = true;
          this.customers = await this.$store.dispatch('partner/search', '?name=' + query + '&type=customer');
          this.customerLoading = false;
        }
      },

      handleCurrentChange(val) {
        this.currentPage = val;
        this.fetchData();
      },


      handleChange() {
        this.currentPage = 1;
        this.fetchData();
      }
    },
  };
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
